export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";